<template>
  <div>
    <b-row
      class="content-header"
    >
      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="7"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="custom-header-title float-left pr-1 mb-0">
              {{ digitalForm.name }}
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row
      class="content-header v-sticky-sidebar-container service_request_task mx-3"
      style="background: #E0E8F2; border-radius: 6px;"
    >
      <b-col
        class="content-header-right d-md-block df-padding"
        md="12"
        cols="12"
      >
        <!-- Table Container Card -->
        <b-card
          no-body
          class="mb-0"
        >
          <div class="urn-form-wrapper m-4 ">
            <div class="orn-form-header d-flex justify-content-between mb-75">
              <div class="d-form-logo_section" />
              <div class="d-form-no_section text-right">
                <h5>
                  {{ digitalForm.formNumber }}
                </h5>
                <h5>
                  {{ digitalForm.revision }}
                </h5>
              </div>
            </div>
            <div class="urn-repository-order_section">
              <div class="b-form-section-title my-2">
                <h3>redemption of imported urn form 领取特定骨瓮声明</h3>
              </div>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="6"
                    label-cols-lg="3"
                    label="REDEMPTION OF IMPORTED URN (NICHE LOT)*:"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="2"
                    label-cols-lg="1"
                    label="I*,"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="6"
                    label-cols-lg="4"
                    label="Purchaser/authorized representative (NRIC:)* "
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="2"
                    label-cols-lg="1"
                    label="I*,"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="4"
                    label-cols-lg="2"
                    label="Next of Kin (NRIC:)* "
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="7"
                    label-cols-lg="5"
                    label="do hereby acknowledge retrieval of*"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
                <b-col md="7">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="8"
                    label-cols-lg="4"
                    label="unit of the imported Urn, of the File No.*"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="2"
                    label-cols-lg="2"
                    label="Urn File No."
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group
                    label-cols="12"
                    label-cols-md="4"
                    label-cols-lg="4"
                    label="Related File Number"
                    label-for="input-default"
                  >
                    <div
                      class="empty-input__text"
                    ><p
                      emptyDiv="true"
                      data-text="Enter"
                    /></div>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="d-form-warning-text-block">
                <p class="d-form-warning-text">
                  as per below on:
                </p>
                <p class="d-form-warning-text">
                  本人乃新加玻富贵山庄福位购买者 / 购买者之委托人（本人身份证号，文件号码，购买证书编号如上述）现领取如数骨瓮（骨瓮类别与数量如下表纪录
                </p>
              </div>
              <div class="mt-5">
                <b-table-simple
                  bordered
                  responsive
                >
                  <b-tbody>
                    <b-tr>
                      <b-td
                        colspan="5"
                        class="text-center"
                      >
                        <span>Urn Retrieval Record (Please note the accuracy in the relevant Urn and Quantity)</span>
                        <br>
                        <span>领取骨瓮记载 （请选填类别与数量</span>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <td rowspan="2">
                        Tick
                      </td>
                      <td rowspan="2">
                        Type of Urn
                      </td>
                      <td rowspan="2">
                        Urn Code
                      </td>
                      <td rowspan="2">
                        Item File No.
                      </td>
                      <td
                        colspan="2"
                        class="text-center"
                      >
                        Quantity
                      </td>
                    </b-tr>
                    <b-tr>
                      <td class="text-center">
                        NMG
                      </td>
                      <td class="text-center">
                        MPL
                      </td>
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Deep Green Crystal with Buddhist Sutra</span>
                        <br>
                        <span>心若彼岸 （深青琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-CRST-DPGN-1203
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Light Green Crystal with Buddhist Sutra</span>
                        <br>
                        <span>心若彼岸 （浅青琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-CRST-LTGN-1203
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Lavender Crystal with Buddhist Sutra</span>
                        <br>
                        <span>紫罗兰琉璃经文罐</span>
                      </b-td>
                      <b-td>
                        URN0-LAVENDER-CRST-LIULI
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Pink Crystal Liu Li</span>
                        <br>
                        <span>粉红晶琉璃罐</span>
                      </b-td>
                      <b-td>
                        URN0-PINK-CRST-LIULI
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Beeswax Yellow Liu Li</span>
                        <br>
                        <span>蜜蜡黄琉璃罐</span>
                      </b-td>
                      <b-td>
                        URN0-BEES-YELW-LIULI
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Red Onyx</span>
                        <br>
                        <span>写意人生（红玉罐</span>
                      </b-td>
                      <b-td>
                        URN0-ONYX-RED0-0212
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Poppy Jade</span>
                        <br>
                        <span>芙蓉西施玉（芙蓉玉罐</span>
                      </b-td>
                      <b-td>
                        URN0-JADE-POPY-1000
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Royalty Jade</span>
                        <br>
                        <span>皇家白玉</span>
                      </b-td>
                      <b-td>
                        URN0-RY-JADE_ORG
                      </b-td>
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                    <b-tr>
                      <b-td>
                        <b-form-checkbox class="form-custom-input-checkbox" />
                      </b-td>
                      <b-td>
                        <span>Others</span>
                        <br>
                        <span>其他</span>
                      </b-td>
                      <b-td />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                      <b-td class="d-form-table-td-blank-bg" />
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
              <b-row class="mt-5">
                <b-col md="6">
                  <p class="d-form-signature-title">Purchaser / Authorized Representative Signatory
                    <br>
                    <span>购买者/受委托领瓮人签名</span>
                  </p>
                  <div
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.authorized-sign-modal
                    class="form-signature-box"
                  >
                    <div class="form-signature-content">
                      <span
                        v-if="!authorizedSign"
                        class="form-signature-text"
                      >
                        Sign here
                      </span>
                      <b-img
                        v-else
                        :src="authorizedSignSrc"
                        alt="authorized-sign"
                      />
                    </div>
                  </div>
                  <div class="signature-date-block">
                    <p>Name 姓名: </p>
                    <p>Date 日期: </p>
                  </div>
                </b-col>
              </b-row>
              <div class="d-form-border mt-4">
                <h5 class="d-form-office-use-title">
                  For office use 公务用栏
                </h5>
                <b-row>
                  <b-col
                    md="6"
                    class="pr-0"
                  >
                    <div class="padding-20">
                      <p class="d-form-signature-title">
                        Verified by 确认人员:</p>
                      <div
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        v-b-modal.verified-sign-modal
                        class="form-signature-box"
                      >
                        <div class="form-signature-content">
                          <span
                            v-if="!verifiedSign"
                            class="form-signature-text"
                          >
                            Sign here
                          </span>
                          <b-img
                            v-else
                            :src="verifiedSignSrc"
                            alt="authorized-sign"
                          />
                        </div>
                      </div>
                      <div class="signature-date-block">
                        <p>Name 姓名: </p>
                        <p>Date 日期: </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- purchaser signature modal -->
    <b-modal
      id="purchaser-sign-modal"
      ref="purchaser-sign-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Purchaser's Signature"
      @ok="closePurchaserSignModal"
      @cancel="closePurchaserSignModal"
    >
      <div class="">
        <VueSignaturePad
          ref="signaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="options"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          @click="clearPurchaserSign()"
        >
          Clear
        </b-button>
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="savePurchaserSign()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- ./ purchaser signature modal -->
    <!-- authorized signature modal -->
    <b-modal
      id="authorized-sign-modal"
      ref="authorized-sign-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Authorized Signature"
      @ok="closeAuthorizedSignModal"
      @cancel="closeAuthorizedSignModal"
    >
      <div class="">
        <VueSignaturePad
          ref="signaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="options"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          @click="clearAuthorizedSign()"
        >
          Clear
        </b-button>
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="saveAuthorizedSign()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- ./ authorized signature modal -->
    <!-- witnessed signature modal -->
    <b-modal
      id="witnessed-sign-modal"
      ref="witnessed-sign-modal"
      modal-class="status-update-modal sign-modal-adjust"
      centered
      no-stacking
      no-close-on-backdrop
      header-class="front-modal"
      title="Installation Service Handled & Witnessed Signature"
      @ok="closeWitnessedSignModal"
      @cancel="closeWitnessedSignModal"
    >
      <div class="">
        <VueSignaturePad
          ref="signaturePad"
          class="border rounded"
          width="100%"
          height="260px"
          :options="options"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="flat-primary"
          @click="clearWitnessedSign()"
        >
          Clear
        </b-button>
        <b-button
          variant="flat-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="saveWitnessedSign()"
        >
          <span class="align-middle">Save</span>
        </b-button>
      </template>
    </b-modal>
    <!-- ./ witnessed signature modal -->
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BImg, BFormGroup, BFormCheckbox, BTableSimple, BTbody, BTr, BTd,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BImg,
    BFormGroup,
    BFormCheckbox,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
  },
  directives: {
    Ripple,
  },
  props: {
    digitalForm: {
      type: Object,
      required: true,
    },
    topSpacing: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      gender: [],
      genderOptions: [
        { text: 'Male 男', value: 'Male 男' },
        { text: 'Female 女', value: 'Female 女' },
      ],
      need: [],
      needOptions: [
        { text: 'As-Need', value: 'as-need' },
        { text: 'Pre-Needed', value: 'pre-needed' },
      ],
      isPurchaserSign: false,
      purchaserSign: '',
      authorizedSign: false,
      authorizedSignSrc: '',
      verifiedSign: false,
      witnessedSignSrc: '',
      options: {
        penColor: '#000000',
        onBegin: () => { this.$refs.signaturePad.resizeCanvas() },
      },
    }
  },
  methods: {
    closePurchaserSignModal() {
      this.$root.$emit('bv::hide::modal', 'purchaser-sign-modal', '')
    },
    clearPurchaserSign() {
      this.$refs.signaturePad.clearSignature()
    },
    savePurchaserSign() {
      const { data } = this.$refs.signaturePad.saveSignature()
      this.purchaserSign = data
      if (data) {
        this.$root.$emit('bv::hide::modal', 'purchaser-sign-modal', '')
        this.isPurchaserSign = true
      }
    },
    closeAuthorizedSignModal() {
      this.$root.$emit('bv::hide::modal', 'authorized-sign-modal', '')
    },
    clearAuthorizedSign() {
      this.$refs.signaturePad.clearSignature()
    },
    saveAuthorizedSign() {
      const { data } = this.$refs.signaturePad.saveSignature()
      this.authorizedSignSrc = data
      if (data) {
        this.$root.$emit('bv::hide::modal', 'authorized-sign-modal', '')
        this.authorizedSign = true
      }
    },
    closeWitnessedSignModal() {
      this.$root.$emit('bv::hide::modal', 'witnessed-sign-modal', '')
    },
    clearWitnessedSign() {
      this.$refs.signaturePad.clearSignature()
    },
    saveWitnessedSign() {
      const { data } = this.$refs.signaturePad.saveSignature()
      this.witnessedSignSrc = data
      if (data) {
        this.$root.$emit('bv::hide::modal', 'witnessed-sign-modal', '')
        this.witnessedSign = true
      }
    },
  },
}
</script>
